import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'app/core';
import { User } from 'app/core/models';
import { Permission } from 'app/core/enums';
import { Store } from '@ngxs/store';
import { UserState } from '../../state/user/state';

@Injectable({
  providedIn: 'root',
})
export class SettingsGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly store: Store,
  ) {}

  private isAdmin(user: User): boolean {
    if (user?.email?.includes('termsheet.com')) return true;

    return this.authService.hasAnyPermission(
      Permission.SETTINGS_ACCESS,
      Permission.SETTINGS_FIELDS,
      Permission.SETTINGS_IMPORTS,
      Permission.SETTINGS_OBJECT_MANAGER,
      Permission.SETTINGS_PERMISSIONS,
      Permission.SETTINGS_SHEETS,
      Permission.SETTINGS_DROPDOWNS,
      Permission.SETTINGS_CODE,
      Permission.SETTINGS_APPS,
      Permission.SETTINGS_TASK_ROLES,
      Permission.SETTINGS_TASK_TEMPLATES,
      Permission.SETTINGS_USERS,
    );
  }

  canActivate(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isAdmin(this.store.selectSnapshot(UserState.getUser));
  }
}
